import { form } from '../formState'
import * as Texts from '../../../intl'

export function Notes() {
  form.useAddFieldValidation<'label'>('label', (field, _formApi) => {
    const value = (field.value || '').trim()

    if (value.length > 255) {
      return Texts.getSimulationValidationNotesMaxLength()
    }

    return undefined
  })

  return (
    <form.TextField
      label={Texts.getSimulationLabelFieldText()}
      placeholder={Texts.getSimulationNotesPlaceholder()}
      validateOn="change"
      name="label"
      testId="simulation-notes"
      textfieldProps={{
        multiline: true,
        rows: 5,
      }}
    />
  )
}
